import React from 'react'
import { useParams } from 'react-router-dom'
import { faPencil } from '@fortawesome/free-solid-svg-icons'
import {
  getGeneralCourierList,
  getReceivedPayments,
} from 'client/utils/api-routes-payments'
import {
  PixelBreadcrumbs,
  PixelButton,
  PixelCurrency,
  PixelDate,
  PixelFactoryContext,
  PixelHeaderPanel,
  PixelIcon,
  PixelModal,
  PixelPageContainer,
  PixelTopBar,
  Section,
  SectionContent,
  SectionTitle,
} from 'pixel-base'
import styled from 'styled-components'

import UpdateReceivedPayment from './UpdateReceivedPayment'
import { IPixelFactory } from '../../../../../decl.d'
interface IDetails {
  courier_name: string
  bank_name: string
  amount: number
  bank_txn_ref: string
  invoice_reference: string
  payment_notes: string
  payment_gateway_name: string
  date_bank_credited: string
  created_by: string
}
const PaymentReceivedDetail = () => {
  const { showLoader, hideLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const headerRef = React.useRef(null)
  const [courierList, setCourierList] = React.useState([])
  const [bankAccounts, setBankAccounts] = React.useState([])
  const params = useParams()
  const paymentID = params.id
  const [details, setDetails] = React.useState<IDetails>({
    courier_name: '',
    bank_name: '',
    amount: 0,
    bank_txn_ref: '',
    invoice_reference: '',
    payment_notes: '',
    payment_gateway_name: '',
    date_bank_credited: '',
    created_by: '',
  })
  const [showModal, setShowModal] = React.useState(false)
  React.useEffect(() => {
    getAllCourierSummary(paymentID)
    getAllBankAccounts()
    getCouriers()
  }, [])

  const getAllCourierSummary = (paymentID) => {
    showLoader(headerRef)
    getReceivedPayments(paymentID).subscribe((res: any) => {
      setDetails(res.response?.data[0])
      hideLoader(headerRef)
    })
  }
  const getAllBankAccounts = () => {
    getBankAccounts().subscribe((res) => {
      setBankAccounts(res.response?.data)
    })
  }
  const getCouriers = () => {
    getGeneralCourierList().subscribe((res: any) => {
      setCourierList(res.response.data)
    })
  }
  const breadcrumbs = [
    {
      name: 'Received Payments Summary',
      active: false,
      link: '/payments/received-payments',
    },
    {
      name: 'Details',
      active: true,
    },
  ]
  return (
    <>
      <PixelTopBar>
        <PixelBreadcrumbs data={breadcrumbs} />
      </PixelTopBar>
      <PixelPageContainer>
        <Section>
          <PixelHeaderPanel>
            <SectionTitle>Received Payment Detail</SectionTitle>
            <PixelButton
              size="sm"
              onClick={() => {
                setShowModal(true)
              }}
            >
              <PixelIcon color={'white'} icon={faPencil} />
              &nbsp;Edit
            </PixelButton>
          </PixelHeaderPanel>

          <SectionContent ref={headerRef}>
            <InfoItem>
              <Label>Courier Name:</Label>
              <Detail>{details?.courier_name || '--'}</Detail>
            </InfoItem>
            <InfoItem>
              <Label>Bank Name:</Label>
              <Detail>{details?.bank_name || '--'}</Detail>
            </InfoItem>
            <InfoItem>
              <Label>Amount:</Label>
              <Detail>
                {details?.amount == 0 ? (
                  '--'
                ) : (
                  <PixelCurrency value={details?.amount} />
                )}
              </Detail>
            </InfoItem>
            <InfoItem>
              <Label>Transaction Reference:</Label>
              <Detail>{details?.bank_txn_ref}</Detail>
            </InfoItem>

            <InfoItem>
              <Label>Invoice Reference:</Label>
              <Detail>{details?.invoice_reference || '--'}</Detail>
            </InfoItem>
            <InfoItem>
              <Label>Payment Notes:</Label>
              <Detail>{details?.payment_notes}</Detail>
            </InfoItem>
            <InfoItem>
              <Label>Receiving Account :</Label>
              <Detail>{details?.payment_gateway_name || '--'}</Detail>
            </InfoItem>
            <InfoItem>
              <Label>Receiving Date:</Label>
              <Detail>
                {details?.date_bank_credited == '' ? (
                  '--'
                ) : (
                  <PixelDate
                    value={details?.date_bank_credited || '--'}
                    format={'pixelStandard'}
                  ></PixelDate>
                )}
              </Detail>
            </InfoItem>
            <InfoItem>
              <Label>Created By:</Label>
              <Detail>{details?.created_by}</Detail>
            </InfoItem>
          </SectionContent>
        </Section>
      </PixelPageContainer>
      {showModal && (
        <PixelModal
          show={showModal}
          handleClose={() => setShowModal(false)}
          size={'lg'}
          title={'Update a received payment'}
        >
          <UpdateReceivedPayment
            paymentID={paymentID}
            payment={details}
            couriers={courierList}
            handleClose={(data) => {
              setShowModal(false)
              if (data) setDetails(data)
            }}
            bankAccounts={bankAccounts}
          />
        </PixelModal>
      )}
    </>
  )
}

const InfoItem = styled.div`
  display: table;
  table-layout: fixed;
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;

  &:last-child {
    border-bottom: none;
  }
`

const Label = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #8e959b;
  display: table-cell;
  vertical-align: middle;
  padding-right: 10px;
  padding: 10px;
  background-color: #e9ecef;
  width: 40%;
`

const Detail = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #000;
  display: table-cell;
  vertical-align: middle;
  padding-left: 10px;
  width: 60%;
  background-color: #e9ecef78;
`
export default PaymentReceivedDetail
